module.exports = __webpack_public_path__ + "static/media/artwork.63a85708.jpg";